module.exports = __webpack_public_path__ + "img/Task book Numeracy.en.598eb1a9.png";